<template>
  <section>
    <el-button @click="testPrint">测试按钮</el-button>
  </section>
</template>
<script>
import { getLodop } from '../../common/js/LodopFuncs'
export default {
  name: 'CodingTest',
  mixins: [],
  components: {},
  filters: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () { },
  methods: {
    testPrint () {
      let LODOP = getLodop()
      const printLen = LODOP.GET_PRINTER_COUNT()
      for (let i = 0; i < printLen; i++) {
        console.log(LODOP.GET_PRINTER_NAME(i))
      }
      console.log('printLen', printLen)
      const printName = LODOP.GET_PRINTER_NAME(0)
      console.log('printName', printName)
      LODOP.PRINT_INIT('')
      LODOP.SET_PRINT_PAGESIZE(1, 1000, 2000, '')
      LODOP.ADD_PRINT_PDF(0, 0, '100%', '100%', 'http://demowms.hhherp.com/Resource/Temp/StockBarCode_aPZ57x94-151448217.pdf')
      const indexName = LODOP.SET_PRINTER_INDEX('barcode-printer')
      console.log('indexName', indexName)
      LODOP.PRINT()
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// CodingTest.vue?a9eb3584